import { render } from "./GroupInfo.vue?vue&type=template&id=67efe020&scoped=true&ts=true"
import script from "./GroupInfo.vue?vue&type=script&lang=ts"
export * from "./GroupInfo.vue?vue&type=script&lang=ts"

import "./GroupInfo.vue?vue&type=style&index=0&id=67efe020&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67efe020"]])

export default __exports__